import type { WorkshopQuestion } from "../types";

export const WORKSHOP_QUESTIONS_DE: WorkshopQuestion[] = [
  {
    id: "valuable_customer_definition",
    label: "Was macht einen Kunden aus Sicht Ihrer Abteilung wertvoll?",
    help:
      "Beschreiben Sie Kriterien, Signale oder Eigenschaften, die aus Ihrer Abteilungsperspektive zeigen, dass ein Kunde wirklich wertvoll ist."
  },
  {
    id: "high_effort_customers",
    label: "Welche Kunden erzeugen aus Ihrer Sicht besonders hohen Aufwand?",
    help: "Denken Sie an Betreuung, Abstimmung, Lieferung, Komplexität, Sonderwünsche oder interne Belastung."
  },
  {
    id: "strategic_fit",
    label: "Welche Kunden passen strategisch besonders gut zum Unternehmen?",
    help:
      "Beschreiben Sie, welche Kunden langfristig zur Richtung, Positionierung oder Entwicklung des Unternehmens passen."
  },
  {
    id: "bad_fit_signals",
    label: "Welche Signale zeigen früh, dass ein Kunde wahrscheinlich nicht gut passt?",
    help: "Nennen Sie Warnsignale, die Ihre Abteilung heute manchmal zu spät erkennt."
  },
  {
    id: "priority_customers",
    label: "Welche Kundentypen sollten künftig stärker priorisiert werden?",
    help: "Beschreiben Sie Kundengruppen, Branchen, Segmente oder Merkmale, die mehr Fokus verdienen."
  },
  {
    id: "deprioritize_customers",
    label: "Welche Kundentypen sollten weniger aktiv verfolgt werden?",
    help: "Beschreiben Sie Kunden, Leads oder Opportunities, die oft Aufwand erzeugen, aber wenig Wert liefern."
  },
  {
    id: "missing_criteria",
    label: "Welche Kriterien fehlen heute in der gemeinsamen Kundenbewertung?",
    help:
      "Welche Informationen oder Bewertungslogiken müssten früher sichtbar sein, damit bessere Entscheidungen entstehen?"
  },
  {
    id: "department_specific_view",
    label: "Was sieht Ihre Abteilung, was andere Abteilungen häufig nicht sehen?",
    help:
      "Beschreiben Sie Perspektiven, Risiken oder Chancen, die aus Ihrer Abteilungssicht besonders wichtig sind."
  }
];

export const WORKSHOP_QUESTIONS_EN: WorkshopQuestion[] = [
  {
    id: "valuable_customer_definition",
    label: "What makes a customer valuable from your department's perspective?",
    help:
      "Describe criteria, signals or characteristics that show, from your department's perspective, that a customer is truly valuable."
  },
  {
    id: "high_effort_customers",
    label: "Which customers create particularly high effort from your perspective?",
    help: "Think about support, coordination, delivery, complexity, special requests or internal load."
  },
  {
    id: "strategic_fit",
    label: "Which customers are a particularly strong strategic fit for the company?",
    help: "Describe which customers fit the long-term direction, positioning or development of the company."
  },
  {
    id: "bad_fit_signals",
    label: "Which early signals show that a customer is probably not a good fit?",
    help: "Name warning signs that your department sometimes recognizes too late today."
  },
  {
    id: "priority_customers",
    label: "Which customer types should be prioritized more strongly in the future?",
    help: "Describe customer groups, industries, segments or characteristics that deserve more focus."
  },
  {
    id: "deprioritize_customers",
    label: "Which customer types should be pursued less actively?",
    help: "Describe customers, leads or opportunities that often create effort but little value."
  },
  {
    id: "missing_criteria",
    label: "Which criteria are missing in the shared customer evaluation today?",
    help: "Which information or evaluation logic should become visible earlier to enable better decisions?"
  },
  {
    id: "department_specific_view",
    label: "What does your department see that other departments often do not see?",
    help:
      "Describe perspectives, risks or opportunities that are especially important from your department's view."
  }
];

export function getWorkshopQuestions(language: "de" | "en" = "de"): WorkshopQuestion[] {
  return language === "en" ? WORKSHOP_QUESTIONS_EN : WORKSHOP_QUESTIONS_DE;
}
